import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { CodeList } from "../code-list/code-list.entity";
import { CodeListMain } from "./code-list-main.entity";

@Entity("code_list_main_items")
export class CodeListMainItems {

    @PrimaryGeneratedColumn("increment", { name: 'code_list_main_items_id' })
        codeListMainItemId: number;


    @Column({
        type: 'int',
        nullable: false,
        name: 'code_list_main_id'
    })
    codeListMainId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'sale_order_item_id'
    })
    soItemId: number;

    @Column({
        type: 'varchar',
        nullable: false,
        name: 'code'
    })
    code: string;

    @Column({
        type: 'int',
        nullable: false,
        name: 'tracebility_code_id'
    })
    tracebilityCodeId: number;

   @Column({
        type: 'int',
        nullable: false,
        name: 'cartons',
        unsigned:true,
    })
    cartons: number;

    @Column({
        type: 'datetime',
        nullable: false,
        name: 'production_date'
    })
    productionDate: Date;

    @Column({
        type: 'datetime',
        nullable: false,
        name: 'best_before_date'
    })
    bestBeforeDate: Date;
   
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => CodeListMain, info => info.codeListItems, { nullable: false })
    @JoinColumn({ name: 'code_list_main_id' })
    codeListInfo: CodeListMain;

    @Column("int", {
        nullable: false,
        name: "unit_id",
        default:0
    })
    unitId: number;
   
  
}